import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Title, Body } from '@vds/typography';
import { Icon } from '@vds/icons';
import { Line } from '@vds/lines';
import { Button } from '@vds/buttons';
import LocationSearch from './LocationSearch';
import { isIndirectStoresEnabled } from '../../Web/ShippingInfo/ShippingInfoHelper';

const ISPU = (props) => {
  const { storeList, submitISPU } = props;

  const getItemQuantity = (itemQuantity, estimatedReadyByDate, isFavoriteStore, isDirect, deviceAvailable) => {
    const estimatedReadyByDateString = estimatedReadyByDate || '';
    const myDate = new Date(estimatedReadyByDateString);
    const monthName = myDate.toLocaleString('en-us', { month: 'long' });
    const monthDate = myDate.getDate();
    if (isDirect === 'Y' && isFavoriteStore === 'Y' && (itemQuantity === 0 || !deviceAvailable) && !estimatedReadyByDate) {
      return 'Out of stock';
    }
    if (deviceAvailable && !estimatedReadyByDate) {
      return 'In stock';
    }
    if (estimatedReadyByDate) {
      return `Ready by ${monthName} ${monthDate}`;
    }
    return '';
  };
  const formatPhoneNumber = (number) => number && `${number.slice(0, 3)}.${number.slice(3, 6)}.${number.slice(6, 10)}`;

  const renderPickup = (pickupMessage, storeHours) => (
    // eslint-disable-next-line react/no-danger
    <Body size="large" primitive="p">
      <span dangerouslySetInnerHTML={{ __html: pickupMessage }} /> {storeHours}
    </Body>
  );

  const renderPickupHours = (store) => (
    <div>
      {store.ISPUPickupEligible &&
        !store.lockerPickupEligible &&
        !store.doorSidePickupEligible &&
        !store.curbsidePickupEligible &&
        !store.limitedCurbsidePickupEligible &&
        !store.isExpresStore &&
        renderPickup(store.ISPUPickupMessage, store.storeHours)}
      {store.ISPUPickupEligible && store.doorSidePickupEligible && renderPickup('Doorside & In-Store pickup hours:', store.storeHours)}
      {store.ISPUPickupEligible && store.lockerPickupEligible && renderPickup('Locker Pickup & In-Store pickup hours:', store.storeHours)}
      {!store.ISPUPickupEligible && store.lockerPickupEligible && renderPickup('Locker Pickup hours:', store.storeHours)}
      {store.lockerPickupEligible24 && renderPickup(store.lockerPickMessage, '')}
      {!store.ISPUPickupEligible && store.doorSidePickupEligible && renderPickup(store.doorSidePickupMessage, store.storeHours)}
      {store.ISPUPickupEligible && store.curbsidePickupEligible && renderPickup('Curbside & In-Store pickup hours:', store.storeHours)}
      {!store.ISPUPickupEligible && store.curbsidePickupEligible && renderPickup(store.curbsidePickupMessage, store.storeHours)}
      {store.ISPUPickupEligible && store.limitedCurbsidePickupEligible && renderPickup(store.ISPUPickupMessage, store.storeHours)}
      {store.limitedCurbsidePickupEligible && renderPickup(store.curbsidePickupMessage, '')}
      {store.ISPUPickupEligible && store.isExpresStore && renderPickup('Express & In-Store pickup hours:', store.storeHours)}
      {!store.ISPUPickupEligible && store.isExpresStore && renderPickup(store.expressStoreMessage, store.storeHours)}
    </div>
  );
  const renderStores = () => (
    <div>
      {storeList.map((store) => {
        const ariaBtnText = `select at ${store.storeName} ${store.storeAddress1}`;
        const isNoStoreAvailable = (!store.deviceAvailable || store.itemQuantity === 0) && !store.estimatedReadyByDate;
        return (
          (store.isFavoriteStore === 'Y' || !isNoStoreAvailable) && (
            <div style={{ marginTop: '15px' }}>
              {store.isFavoriteStore === 'Y' && (
                <Body size="large">
                  <div style={{ display: 'flex' }}>
                    <div style={{ marginRight: '3px' }}>
                      <Icon name="added-to-favorite" size="medium" color="red" />
                    </div>
                    My store
                  </div>
                </Body>
              )}
              <div style={{ display: 'flex' }}>
                <div style={{ width: '65%' }}>
                  <Body size="large" primitive="p" bold>
                    {store.storeName}
                  </Body>
                  {isIndirectStoresEnabled() && (
                    <>
                      <Body size="large" primitive="p">
                        {store?.storeType}
                      </Body>
                      &nbsp;
                    </>
                  )}
                  <Body size="large" primitive="p">
                    {store.storeAddress1}
                  </Body>
                  <Body size="large" primitive="p">
                    {store.storeAddress2}
                  </Body>
                  <Body size="large" primitive="p">
                    {formatPhoneNumber(store.phoneNumber)}
                  </Body>
                  <Body size="large" primitive="p">
                    {store.distance} miles
                  </Body>
                </div>
                <div style={{ textAlign: 'end', width: '35%' }}>
                  <Body size="large" primitive="p" bold>
                    {getItemQuantity(store.itemQuantity, store.estimatedReadyByDate, store.isFavoriteStore, store.direct, store.deviceAvailable)}
                  </Body>
                </div>
              </div>
              <div style={{ marginTop: '12px' }}>{renderPickupHours(store)}</div>
              <div style={{ marginTop: '12px' }}>
                {isNoStoreAvailable ? (
                  <Body bold size="large">
                    Select another store for pickup
                  </Body>
                ) : (
                  <Button
                    ariaLabel={ariaBtnText}
                    size="small"
                    secondary
                    onClick={() => submitISPU(store)}
                    data-track={`{"type":"link","name":"select location -${getItemQuantity(store.itemQuantity, store.estimatedReadyByDate, store.isFavoriteStore, store.direct, store.deviceAvailable)}"}`}
                  >
                    Select location
                  </Button>
                )}
              </div>
              <Line type="xLight" style={{ marginTop: '15px' }} />
            </div>
          )
        );
      })}
    </div>
  );
  return (
    <Fragment>
      <div style={{ maxWidth: '700px', minHeight: '309px' }}>
        <Title size="large" primitive="h2">
          Choose a store for pickup
        </Title>
        <div style={{ marginTop: '24px' }}>
          <Body size="large">Pickup order normally processed in 1 hour.</Body>
        </div>
        <div style={{ marginTop: '16px' }}>
          <Body size="small" primitive="p">
            The availability of devices for in-store pickup depends on the inventory of each store, which can change. Pickup options may not be
            available for all devices.
          </Body>
        </div>
        <div style={{ marginTop: '24px', maxWidth: '425px' }}>
          <LocationSearch {...props} />
        </div>
        {props.inventoryCheckInfo && props.inventoryCheckInfo.title && (
          <div style={{ marginTop: '32px' }}>
            <Body size="large" bold>
              {props.inventoryCheckInfo.title}
            </Body>
            <Body size="large" bold>
              {props.inventoryCheckInfo.content}
            </Body>
          </div>
        )}
        {renderStores()}
      </div>
    </Fragment>
  );
};

ISPU.defaultProps = {
  storeList: [],
  submitISPU: () => {},
};

ISPU.propTypes = {
  submitISPU: PropTypes.func,
  storeList: PropTypes.array,
  inventoryCheckInfo: PropTypes.object,
};

export default ISPU;
